import { PATH_NUMBER_TYPE } from "@visactor/vrender-core";

import { PickerBase } from "../common/base";

export class DefaultMathPathPicker extends PickerBase {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "path", this.numberType = PATH_NUMBER_TYPE;
    }
}
//# sourceMappingURL=path-picker.js.map
